var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitterBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 16.5,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3996 10.1546C25.6717 10.478 24.8883 10.6958 24.0667 10.7941C24.9055 10.2912 25.5496 9.49533 25.8525 8.54698C25.0685 9.01291 24.198 9.35015 23.2734 9.53295C22.5323 8.74365 21.4757 8.25 20.3082 8.25C18.065 8.25 16.2462 10.0688 16.2462 12.312C16.2462 12.6301 16.2825 12.9403 16.3518 13.2379C12.9754 13.069 9.98254 11.4514 7.97892 8.99377C7.62914 9.59367 7.42917 10.2912 7.42917 11.0357C7.42917 12.4447 8.14523 13.688 9.23613 14.4166C8.56958 14.3955 7.94394 14.2127 7.39551 13.9085V13.9593C7.39551 15.9279 8.7966 17.5692 10.6537 17.9434C10.3132 18.0358 9.95417 18.086 9.58393 18.086C9.32193 18.086 9.06718 18.0602 8.81904 18.0127C9.33579 19.6263 10.8365 20.801 12.6138 20.834C11.2239 21.923 9.4724 22.573 7.56908 22.573C7.24043 22.573 6.91705 22.5539 6.59961 22.5156C8.39733 23.6679 10.5323 24.341 12.8263 24.341C20.2977 24.341 24.3834 18.1513 24.3834 12.7839C24.3834 12.6077 24.3801 12.4321 24.3716 12.2586C25.1662 11.6844 25.8551 10.969 26.3996 10.1546Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterBlack);
export default __webpack_public_path__ + "static/media/twitterBlack.d3f54d7c.svg";
export { ForwardRef as ReactComponent };